<template>
  <div class="w-full h-80">
    <canvas ref="chartCanvas"></canvas>
  </div>
</template>

<script setup lang="ts">
import {
  Chart,
  BarController,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  type ChartTypeRegistry,
  type ScatterDataPoint,
  type BubbleDataPoint,
} from 'chart.js';

// Register components
Chart.register(BarController, CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const chartCanvas = ref<HTMLCanvasElement | null>(null);
let chartInstance: Chart<
  keyof ChartTypeRegistry,
  (number | ScatterDataPoint | BubbleDataPoint | null)[],
  unknown
> | null = null;

const props = defineProps<{
  labels: string[]
  values: number[]
  color?: string
  label?: string
}>();

const createChart = () => {
  if (!chartCanvas.value) return;

  chartInstance = new Chart(chartCanvas.value, {
    type: 'bar',
    data: {
      labels: props.labels,
      datasets: [
        {
          label: props.label || 'Value',
          data: props.values,
          backgroundColor: props.color || '#233255',
          barPercentage: 0.5,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        y: { beginAtZero: true },
      },
      plugins: {
        legend: { display: true },
      },
    },
  });
};

onMounted(createChart);

// ✅ Fix: safely update chart only if chartInstance exists
watch(
  () => props.values,
  () => {
    if (chartInstance?.data?.datasets?.[0]) {
      chartInstance.data.datasets[0].data = props.values;
      chartInstance.update();
    }
  },
);
</script>
